import GroupCostBox from './GroupCostBox'
export default GroupCostBox
